import React from 'react'
import { Carousel } from 'antd'
import style from './style.module.scss'
import CodeSqIcon from '../../../assets/cometchat/images/code-square-02.svg'
// import AwardsImage from '../../../assets/cometchat/images/awards.svg'
import MedalImage1 from '../../../assets/cometchat/images/medal1.svg'
import MedalImage2 from '../../../assets/cometchat/images/medal2.svg'
import MedalImage3 from '../../../assets/cometchat/images/medal3.svg'
import MedalImage4 from '../../../assets/cometchat/images/medal4.svg'
import MedalImage5 from '../../../assets/cometchat/images/medal5.svg'
import SlideIcon1 from '../../../assets/cometchat/images/boatyard.png'
import SlideIcon2 from '../../../assets/cometchat/images/fruitlab.png'
import SlideIcon3 from '../../../assets/cometchat/images/kahoot.png'
import SlideIcon4 from '../../../assets/cometchat/images/turbotenant.jpeg'
import SlideIcon5 from '../../../assets/cometchat/images/mediamonks.png'
import UserAvatar1 from '../../../assets/cometchat/images/ua_boatyard.png'
import UserAvatar2 from '../../../assets/cometchat/images/ua_default.png'
import UserAvatar3 from '../../../assets/cometchat/images/ua_kahoot.png'
import UserAvatar4 from '../../../assets/cometchat/images/ua_turbotenant.png'
import UserAvatar5 from '../../../assets/cometchat/images/ua_mediamonks.png'
import SlideWrapper from './SlideWrapper'

const RightHandSideContainer = () => {
  const RightHandSideContainerClasses = `${style.RightHandSideContainer} col-xl-6 col-md-12 col-xs-12 col-sm-12`
  return (
    <div className={RightHandSideContainerClasses}>
      <div className={style.RightHandSideContainerInner}>
        <div className="codeIcon">
          <img src={CodeSqIcon} alt="CodeSqIcon" />
        </div>
        <h2
          style={{
            margin: '0px',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '160%',
            marginBottom: '34px',
          }}
        >
          CometChat powers real-time messaging and voice & video calling for 1000s of brands
        </h2>
        <div className="carousel">
          <Carousel autoplay>
            {' '}
            <SlideWrapper
              icon={SlideIcon1}
              comment="&ldquo; CometChat's fully-featured SDK, UI Kits, and robust documentation compared well with competitors. From the initial deployment to the release of our platform, we didn’t see that level of support with any other chat solution. &rdquo;"
              avatar={UserAvatar1}
              userName="Nathan Heber"
              userRole="CEO & Founder, Boatyard"
            />
            <SlideWrapper
              icon={SlideIcon2}
              comment="&ldquo; Building chat is a costly thing. I can't see the point of building a new chat system. It’s a business in itself, upgrades and all of that. It’s just not possible to sustain the costs. We want to focus on our core in terms of who we are. I mean, we're a gaming platform. Using a third-party is the right choice. &rdquo;"
              avatar={UserAvatar2}
              userName="Abdel Hosen"
              userRole="Head of Development, Fruitlab"
            />
            <SlideWrapper
              icon={SlideIcon3}
              comment="&ldquo; It's as if we've unlocked a new level of communication within our app. Plus, the responsive support and commitment to addressing our specific needs have been exceptional. We're thrilled with the results and recommend CometChat to any company looking to elevate their communication strategy. &rdquo;"
              avatar={UserAvatar3}
              userName="Ingrid Pauchon"
              userRole="Product Manager, Kahoot!"
            />
            <SlideWrapper
              icon={SlideIcon4}
              comment="&ldquo; We’ve received largely positive feedback since we integrated CometChat into our platform. It has improved their experience and made it easier for them to communicate with each other. &rdquo;"
              avatar={UserAvatar4}
              userName="Sara Capra"
              userRole="Senior Product Manager, TurboTenant"
            />
            <SlideWrapper
              icon={SlideIcon5}
              comment="&ldquo; The look and feel of every event is different. It's never the same. We develop a new front-end every time per customer requests. CometChat makes that rapid customization possible. &rdquo;"
              avatar={UserAvatar5}
              userName="Anna Hovhannisyan"
              userRole="Senior Project Manager, Media.Monks"
            />
          </Carousel>
        </div>
        {/* <div className="awardsList mt-5">
          <img src={AwardsImage} alt="Awards" width="120%" />
        </div> */}
        <div className="medalsList mt-5" style={{ display: 'flex' }}>
          <img src={MedalImage4} alt="Medal 1" width="75px" />
          <img src={MedalImage2} alt="Medal 2" width="90px" />
          <img src={MedalImage1} alt="Medal 1" width="110px" />
          <img src={MedalImage3} alt="Medal 4" width="90px" />
          <img src={MedalImage5} alt="Medal 5" width="75px" />
        </div>
      </div>
    </div>
  )
}

export default RightHandSideContainer
